import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'simulatede.edition.title',
    defaultMessage: 'SIMULATED EDITION',
  },
  back: {
    id: 'simulated.edition.back',
    defaultMessage: 'Back',
  },
  share: {
    id: 'simulated.edition.share',
    defaultMessage: 'Share',
  },
  contentMapAndAbilitys: {
    id: 'simulated.edition.contentMapAndAbilitys',
    defaultMessage: 'Content map / abilities',
  },
  abilitiesRegistred: {
    id: 'simulated.edition.abilitiesRegistred',
    defaultMessage: 'registred abilities',
  },
  abilitiesAvaliable: {
    id: 'simulated.edition.abilitiesAvaliable',
    defaultMessage: 'avaliable abilities',
  },
  abilitiesApproved: {
    id: 'simulated.edition.abilitiesApproved',
    defaultMessage: 'approved abilities',
  },
  to: {
    id: 'simulated.edition.to',
    defaultMessage: 'to',
  },
  edit: {
    id: 'simulated.edition.edit',
    defaultMessage: 'Edit',
  },
  finished: {
    id: 'simulated.edition.finished',
    defaultMessage: 'Completed',
  },
  disabled: {
    id: 'simulated.edition.disabled',
    defaultMessage: 'Disabled',
  },
  questionsTitle: {
    id: 'simulated.edition.questionsTitle',
    defaultMessage: 'Questions',
  },
  questions: {
    id: 'simulated.edition.questions',
    defaultMessage: 'questions',
  },
  delay: {
    id: 'simulated.edition.delay',
    defaultMessage: '{delay} day delay',
  },
  class: {
    id: 'simulated.edition.class',
    defaultMessage: 'Class',
  },
  school: {
    id: 'simulated.edition.school',
    defaultMessage: 'School',
  },
  completed: {
    id: 'simulated.edition.completed',
    defaultMessage: 'Completed',
  },
  download: {
    id: 'simulated.edition.download',
    defaultMessage: 'Download',
  },
  cancel: {
    id: 'simulated.edition.cancel',
    defaultMessage: 'Cancel',
  },
  kitTitle: {
    id: 'simulated.edition.kitTitle',
    defaultMessage: 'Simulated Kit',
  },
  simulatedPdf: {
    id: 'simulated.edition.simulatedPdf',
    defaultMessage: 'Simulated PDF',
  },
  answersPdf: {
    id: 'simulated.edition.answersPdf',
    defaultMessage: 'PDF of the template',
  },
  answersCardPdf: {
    id: 'simulated.edition.answersCardPdf',
    defaultMessage: 'PDF of answer cards',
  },
  selectSchoolTitle: {
    id: 'simulated.edition.selectSchoolTitle',
    defaultMessage: 'Select school',
  },
  sendCardsSubtitle: {
    id: 'simulated.edition.sendCardsSubtitle',
    defaultMessage: 'Sending scanned response cards',
  },
  uploadCardsInfo: {
    id: 'simulated.edition.uploadCardsInfo',
    defaultMessage: 'To make the correction, please upload the answer sheets',
  },
  uploadButton: {
    id: 'simulated.edition.uploadButton',
    defaultMessage: 'Upload',
  },
  disabledButton: {
    id: 'simulated.edition.disabledButton',
    defaultMessage: 'Disable',
  },
  forbidden: {
    id: 'simulated.edition.forbidden',
    defaultMessage: 'Content not available.',
  },
  filter: {
    id: 'simulated.edition.filter',
    defaultMessage: 'Filters',
  },
  catalogingSubtitle: {
    id: 'simulated.edition.catalogingSubtitle',
    defaultMessage:
      '{name} - {quantity} questions - {quantityAbilities} abilities - {questionsPerAbility} questions per abilities',
  },
  pdfFileName: {
    id: 'simulated.edition.pdfFileName',
    defaultMessage: 'evaluation-kit-{idEvaluation}-{idCSchool}.zip',
  },
  follow: {
    id: 'simulated.edition.follow',
    defaultMessage: 'Follow',
  },
  followCardTitle: {
    id: 'simulated.edition.followCardTitle',
    defaultMessage: 'Online Application',
  },
  followCardText: {
    id: 'simulated.edition.followCardText',
    defaultMessage: 'Track the status of the evaluation done by students',
  },
  important: {
    id: 'simulated.edition.important',
    defaultMessage: 'Important',
  },
  readMePrintTitle: {
    id: 'simulated.edition.readMePrintTitle',
    defaultMessage: 'For the response card correction process to run smoothly, you need to:',
  },
  readMePrintConfig: {
    id: 'simulated.edition.readMePrintConfig',
    defaultMessage: 'The printing of the response cards must follow the settings below:',
  },
  readMePrintColor: {
    id: 'simulated.edition.readMePrintColor',
    defaultMessage: 'Print Color: Black and White',
  },
  readMePrintMode: {
    id: 'simulated.edition.readMePrintMode',
    defaultMessage: 'Print mode: Laser and normal [NEVER draft mode]',
  },
  readMePrintPaper: {
    id: 'simulated.edition.readMePrintPaper',
    defaultMessage: 'Paper: white and A4 size',
  },
  readMePrintOnlyFront: {
    id: 'simulated.edition.readMePrintOnlyFront',
    defaultMessage: 'Please print only one sheet per sheet [NEVER use double-sided]',
  },
  noFilesToDownload: {
    id: 'simulated.edition.noFilesToDownload',
    defaultMessage: 'The are no files to download',
  },
  all: {
    id: 'simulated.edition.all',
    defaultMessage: 'All',
  },
  selectGroups: {
    id: 'simulated.edition.selectGroups',
    defaultMessage: 'Select groups',
  },
  evaluationOnline: {
    id: 'simulated.edition.evaluationOnline',
    defaultMessage: 'Online evaluation',
  },
  scheduledFor: {
    id: 'simulated.edition.scheduledFor',
    defaultMessage: 'Scheduled for',
  },
  followup: {
    id: 'simulated.edition.followup',
    defaultMessage: 'Follow up',
  },
  until: {
    id: 'simulated.edition.until',
    defaultMessage: 'until',
  },
  readMeScanConfig: {
    id: 'simulated.edition.readMeScanConfig',
    defaultMessage: 'The scanning of the response cards must follow the settings below:',
  },
  readMeScanResolution: {
    id: 'simulated.edition.readMeScanResolution',
    defaultMessage: 'Resolution: 300 dpi and grayscale',
  },
  readMeScanPosition: {
    id: 'simulated.edition.readMeScanPosition',
    defaultMessage: 'Position: vertical',
  },
  readMeScanType: {
    id: 'simulated.edition.readMeScanType',
    defaultMessage: 'Type: JPG or PNG',
  },
  readMeScanAlign: {
    id: 'simulated.edition.readMeScanAlign',
    defaultMessage: 'All images must be aligned and with the header up',
  },
  readMeScanOnlyOneResponseCard: {
    id: 'simulated.edition.readMeScanOnlyOneResponseCard',
    defaultMessage: 'Each file must contain only one answer card',
  },
  readMeScanNoBlankCards: {
    id: 'simulated.edition.readMeScanNoBlankCards',
    defaultMessage: 'Blank forms must NOT be sent',
  },
  readMeScanAttention: {
    id: 'simulated.edition.readMeScanAttention',
    defaultMessage:
      'Files that DO NOT follow the standards established above will not be corrected and must be validated by the school itself in the "Audit" environment located on the card of its respective simulation.',
  },
  loadingMessage: {
    id: 'simulated.edition.loadingMessage',
    defaultMessage: 'Processing answer sheet files. Please, wait!',
  },
  compositionSheets: {
    id: 'simulated.edition.compositionSheets',
    defaultMessage: 'PDF of Composition sheets',
  },
  writingProposal: {
    id: 'simulated.edition.writingProposal',
    defaultMessage: ' PDF of Writing proposal',
  },
  sendComposingSubtitle: {
    id: 'simulated.edition.sendComposingSubtitle',
    defaultMessage: 'Sending scanned composition sheets',
  },
  uploadComposingInfo: {
    id: 'simulated.edition.uploadComposingInfo',
    defaultMessage:
      'To make the correction, it is necessary to upload the composition sheets of your students',
  },
  downloadComposingDOCSubtitle: {
    id: 'simulated.edition.downloadComposingDOCSubtitle',
    defaultMessage: 'Writing correction guidelines',
  },
  first_grade: {
    id: 'simulated.edition.first_grade',
    defaultMessage: '1º Grade',
  },
  second_grade: {
    id: 'simulated.edition.second_grade',
    defaultMessage: '2º Grade',
  },
  third_grade: {
    id: 'simulated.edition.third_grade',
    defaultMessage: '3º Grade',
  },
  sixth_year: {
    id: 'simulated.edition.sixth_year',
    defaultMessage: '6th year',
  },
  seventh_year: {
    id: 'simulated.edition.seventh_year',
    defaultMessage: '7th year',
  },
  eighth_year: {
    id: 'simulated.edition.eighth_year',
    defaultMessage: '8th year',
  },
  ninth_year: {
    id: 'simulated.edition.ninth_year',
    defaultMessage: '9th year',
  },
});
